import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from './ProjectCard';
import personal_project1 from '../assets/img/personal_project1.png'
import personal_project2 from '../assets/img/personal_project2.png'
import personal_project3 from '../assets/img/personal_project3.png'
import collaborative_project1 from '../assets/img/collab_project1.png'
import collaborative_project2 from '../assets/img/collab_project2.png'
import collaborative_project3 from '../assets/img/collab_project3.png'


export const Projects = () => {
    
    const personal_projects = [
        {
            title: "This website!",
            description: "Personal portfolio website with my own custom designs",
            imgUrl: personal_project1,
            projUrl: '',
        },
        {
            title: "Notes respository",
            description: "Collection of notes/cheatsheets I have taken from mods in NUS SOC",
            imgUrl: personal_project2,
            projUrl: 'https://github.com/ZHTang29/nus-notes-cheatsheets',    
        },
        {
            title: "Duke",
            description: "Simple yet elegant to-do list chatbot",
            imgUrl: personal_project3,
            projUrl:'https://github.com/ZHTang29/ip',
        },
    ];

    const collaborative_projects = [
        {
            title: "Perhe Wolves Website",
            description: "Club website for my floorball team",
            imgUrl: collaborative_project3,
            projUrl: 'https://perhewolves.com',
        },
        {
            title: "RIZZipe",
            description: "Desktop app for easily managing recipes. Done for CS2103T",
            imgUrl: collaborative_project1,
            projUrl: 'https://github.com/ZHTang29/tp',
        },
        {
            title: "Game of Life",
            description: "Multithreaded implementation of Conway's GOL. Done for CS3210",
            imgUrl: collaborative_project2,
            projUrl: 'https://github.com/ZHTang29/game-of-life',
        }
    ];
    
    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col>
                      <h2>Projects</h2>
                      <p>These are the personal/collaborative projects I have worked on in the past! Feel free to check them out on my Github!</p>
                      <Tab.Container id="projects-tabs" defaultActiveKey="first">
                      <Nav Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                        <Nav.Item>
                            <Nav.Link eventKey="first">Personal</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="second">Collaborations</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                            <Row>
                                {
                                    personal_projects.map((project, index) => {
                                        return (
                                            <ProjectCard
                                              key={index}
                                              {...project}
                                              />
                                        )
                                    })
                                }
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                            <Row>
                                {
                                    collaborative_projects.map((project, index) => {
                                        return (
                                            <ProjectCard
                                              key={index}
                                              {...project}
                                              />
                                        )
                                    })
                                }
                            </Row>
                        </Tab.Pane>
                      </Tab.Content>
                      </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}